// extracted by mini-css-extract-plugin
export default {"communication":"communication_communication__9ydN4"};